export const FOR_DAYS_REGEXP = /^for\d+Days$/;
export const DIGITS_REGEXP = /\D/g;

export const NO_INVESTOR_WARNINGS = [];
